<!-- Instagram Explore home -->
<div class="ige">
  <ng-container *ngFor="let tile of tiles">
    <a
      *ngIf="tile === adTile; else placeholder"
      class="ige-tile ige-promo"
      [attr.href]="data.url || null"
      target="_blank"
      rel="noopener noreferrer"
    >
      <app-meta-creative class="ige-creative" [src]="data.creative" [kind]="data.creativeKind" slot="cover"></app-meta-creative>
      <span class="ige-badge">
        <img class="ige-avatar" [src]="avatar" alt="" />
        <span>Oglas</span>
      </span>
    </a>
    <ng-template #placeholder><span class="ige-tile"></span></ng-template>
  </ng-container>
</div>
